import { render, staticRenderFns } from "./message-queue-confirmation.vue?vue&type=template&id=0180b762&scoped=true"
import script from "./message-queue-confirmation.vue?vue&type=script&lang=ts"
export * from "./message-queue-confirmation.vue?vue&type=script&lang=ts"
import style0 from "./message-queue-confirmation.vue?vue&type=style&index=0&id=0180b762&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0180b762",
  null
  
)

export default component.exports